import { Button } from '@repo/design-system-kit/components/button/button';
import { LottiePlayer } from '@repo/design-system-kit/components/lottie-player/lottie-player';
import errorLottie from '@repo/visual-assets/dotlottie/lottie_pop_general_error404.lottie';
import { FormattedMessage } from 'react-intl';
import cx from 'clsx';
import { useNavigate } from '@repo/poly-hooks/routing';
import styles from './not-found.module.css';

export function NotFound(): React.JSX.Element {
  const navigate = useNavigate();

  function handleBackToHome(): void {
    navigate('/', { replace: true });
  }

  return (
    <div className={cx('mb-32', styles.mainContainer)}>
      <div className={styles.content}>
        <LottiePlayer className={styles.illustration} src={errorLottie} />
        <h1 className="heading-section mb-16" data-test-404-title>
          <FormattedMessage id="404.title" />
        </h1>
        <p className="body-standard mb-32" data-test-404-subtitle>
          <FormattedMessage id="404.subtitle" />
        </p>
        <Button data-test-404-back-btn onClick={handleBackToHome}>
          <FormattedMessage id="generic.go-back-to-app.cta" />
        </Button>
      </div>
    </div>
  );
}
